import { FC } from 'react'
import { CsvParserErrorType } from '@pubstack/common/src/csv-parser-error'

const ErrorList = ({ children }: { children: React.ReactNode }) => <ul className="m-0 mb-4 ml-4 list-disc list-inside p-0">{children}</ul>

export const ErrorListDisplay: FC<{ errors: CsvParserErrorType[] }> = ({ errors }) => {
  const hasForbiddenChars = errors.some((e) => typeof e !== 'string' && e.message === 'contains forbidden characters')

  return (
    <>
      <ErrorList>
        {errors.map((e) => {
          if (typeof e === 'string') return <li key={e}>{e}</li>

          const { row, actualValue, message } = e
          const key = `${row ?? ''}-${actualValue ?? ''}-${message}`

          if (row && actualValue) return <li key={key}>{`l${row}: "${actualValue}" ${message}`}</li>
          if (row) return <li key={key}>{`l${row}: ${message}`}</li>
          return <li key={key}>{message}</li>
        })}
      </ErrorList>
      {hasForbiddenChars && (
        <>
          <br />
          <p style={{ margin: 0 }}>Spaces, quotes and the following characters are forbidden: ,;:?&lt;&gt;=</p>
        </>
      )}
    </>
  )
}
